export const publish = (name, data) => {
  return $.publish(name, data);
}